import React, { Component } from 'react';
import {
  Segment,
} from 'semantic-ui-react';
import { shape, bool } from 'prop-types';
import ChatEmpty from 'Assets/images/commons/chat_empty.svg';
import styles from './MessageHome.less';

const waitingTime = 1000;

class MessageHome extends Component {
  state = {
    waiting: true,
  }

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({
        waiting: false,
      });
    }, waitingTime);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    return (
      <Segment className="message-home">
        <div style={{ textAlign: 'center' }}>
          <div className="wrap-image" style={{ backgroundImage: `url(${ChatEmpty})` }} />
        </div>
      </Segment>
    );
  }
}

MessageHome.propTypes = {
  loading: bool.isRequired,
  user: shape({}).isRequired,
};

MessageHome.defaultProps = {
};

export default MessageHome;
